import { CommonModule } from '@angular/common';
import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { Router } from '@angular/router';
import { ChatWidgetComponent } from 'src/app/shared/components/widgets/chat-widget/chat-widget.component';

@Component({
  selector: 'app-footer-more-info',
  standalone: true,
  imports: [ChatWidgetComponent, CommonModule],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: './footer-more-info.component.html',
  styleUrl: './footer-more-info.component.scss'
})
export class FooterMoreInfoComponent {
  [key: string]: any;
  constructor() {}

  goTo(link:any) {}
}
